export default {
  feedback: {
    success: 'Aplicația mobilă a fost salvată cu succes',
    error: 'Eroare la salvarea aplicației mobile',
  },
};
